import img from '../assets/images/main-image.png'
import img2 from '../assets/images/Cyber Space.png'



const Trainings = [
    {
        id: Math.floor(Math.random()* 100000).toString(),
        title: 'Técnico FP',
        description: "aqui va la descrpción de la titulación",
        detalles: ["detalle1", "detalle2","detalle3","detalle4","detalle5","detalle6",],
        img:img
    },
    {
        id: Math.floor(Math.random()* 100000).toString(),
        title: 'Técnico Superior FP',
        description: "aqui va la descrpción de la titulación",
        detalles: ["detalle1", "detalle2","detalle3","detalle4","detalle5","detalle6",],
        img:img2
    },
    {
        id: Math.floor(Math.random()* 100000).toString().length === 2,
        title: 'Bootcamp',
        description: "aqui va la descrpción de la titulación",
        detalles: ["detalle1", "detalle2","detalle3","detalle4","detalle5","detalle6",],
        img:img
    },
    {
        id: Math.floor(Math.random() * 100000).toString(),
        title: 'Bootcamp Hack',
        description: "aqui va la descrpción de la titulación",
        detalles: ["detalle1", "detalle2","detalle3","detalle4","detalle5","detalle6",],
        img:img2
    },
    {
        id: Math.floor(Math.random()* 100000).toString(),
        title: 'Técnico F P',
        description: "aqui va la descrpción de la titulación",
        detalles: ["detalle1", "detalle2","detalle3","detalle4","detalle5","detalle6",],
        img:img
    },
    {
        id: Math.floor(Math.random()* 100000).toString(),
        title: 'Técnico Superior',
        description: "aqui va la descrpción de la titulación",
        detalles: ["detalle1", "detalle2","detalle3","detalle4","detalle5","detalle6",],
        img:img2
    },
]


export default Trainings